import { CurrentEnvironment } from "shared/Modules/Environment/envTypes";
import { ApiResponse, ApiResponseTypes, ISuccessResponse } from "shared/Types/responseTypes";
import { get, getHeadersFromOptions, post } from "shared/Helpers/http"
import { IMeetingServiceOrderPayload } from "../../../Types/MeetingPlanning/createMeetingServiceOrder"
import { IBillReceiversResponse } from "../../../Types/MeetingPlanning/billReceivers"
import { IExtraServicesList } from "../../../Types/MeetingPlanning/extraServices"
import { IServiceCenterList, ResourceType } from "../../../Types/MeetingPlanning/userResources"
import { IMeetingServiceConfigResponse } from "../../../Types/MeetingPlanning/meetingServiceConfiguration"

const MOCK_API_URL = 'https://516f60fe-6c1a-4eca-8b8b-5ffbf30a2932.mock.pstmn.io'

type AccountingDimensionDetails = Readonly<{
    id: number
    name: string
    values: Array<{ value: string; label: string }>
}>

type DimensionDetailsParams = Readonly<{
    companyId: number
    dimensionId: number
    search?: string
}>
export type DimensionDetailsResponse = Readonly<{
    accountingDimension: AccountingDimensionDetails
}>

// TODO: This is temporary mock for get Dimension Details this will be replace with code below:

// export const fetchDimensionDetailsForCompany = (
//     token: string,
//     environment: CurrentEnvironment,
//     { companyId, dimensionId, search }: DimensionDetailsParams
// ): Promise<ApiResponse<DimensionDetailsResponse>> => {
//     // Call API
//     const url = `/companies/${companyId}/accounting/dimensions/${dimensionId}${search ? `?search=${search}` : ''}`
//     return http(new Request(ApiHelper.path(url), {
//         method: 'GET',
//         headers: getHeadersFromOptions({ token, environment })
//     }));
// };

export const fetchDimensionDetailsForCompany = async (
    token: string,
    environment: CurrentEnvironment,
    { companyId, dimensionId, search }: DimensionDetailsParams
): Promise<ApiResponse<DimensionDetailsResponse>> => {
    const response = await fetch(
        `${MOCK_API_URL}/companies/${companyId}/accounting/dimensions/${dimensionId}?search=${search}`,
        {
            method: 'GET',
            headers: getHeadersFromOptions({ token, environment }),
        }
    );

    const text = await response.text();

    try {
        const data = JSON.parse(text);

        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: 'GET',
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: []
        } as ISuccessResponse<DimensionDetailsResponse>;
    } catch {
        throw Error('Impossible to parse data')
    }
};

// TODO: This is temporary mock for get Meeting Service Configuration this will be replace with code below:
// export const getMeetingServiceConfiguration = (
//     token: string,
//     environment: CurrentEnvironment,
// ): Promise<ApiResponse<any>> => http(new Request(ApiHelper.path('/me/meetingService/config'), {
//     method: 'GET',
//     headers: getHeadersFromOptions({ token, environment })
// }))

export const createMeetingServiceOrder = (
    userId: number,
    payload: IMeetingServiceOrderPayload,
    token: string,
    environment: CurrentEnvironment
): Promise<ApiResponse<any>> => {
    return post(`/users/${userId}/orders/meetingService`, {
        body: payload,
        token,
        environment,
    })
}

export const updateMeetingServiceOrder = (
    userId: number,
    orderId: number,
    payload: IMeetingServiceOrderPayload,
    token: string,
    environment: CurrentEnvironment
): Promise<ApiResponse<any>> => {
    return post(`/users/${userId}/orders/meetingService/${orderId}`, {
        body: payload,
        token,
        environment,
    })
}

export const fetchResources = (
    token: string,
    userId: number,
    environment: CurrentEnvironment,
    resourcesTypes: ResourceType
): Promise<ApiResponse<IServiceCenterList>> => {
    return get(`/users/${userId}/resources?resourceTypes=${resourcesTypes}`, {
        token,
        environment,
    })
}

// TODO: This is temporary mock for get extra services this will be replace with code below:
// export const fetchMerchantProductsExtraServices = (
//     token: string,
//     merchantId: number | undefined,
//     environment: CurrentEnvironment
// ): Promise<ApiResponse<IExtraServicesList>> => {
//     return get(`/merchants/${merchantId}/services`, {
//         token,
//         environment,
//     })
// }

export const fetchMerchantProductsExtraServices = async (
    token: string,
    merchantId: number | undefined,
    environment: CurrentEnvironment
): Promise<ApiResponse<IExtraServicesList>> => {
    const response = await fetch(
        `${MOCK_API_URL}/merchants/${merchantId}/services`,
        {
            method: 'GET',
            headers: getHeadersFromOptions({ token, environment }),
        }
    );

    const text = await response.text();

    try {
        const data = JSON.parse(text);
        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: 'GET',
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: []
        } as ISuccessResponse<IExtraServicesList>;
    } catch {
        throw Error('Impossible to parse data')
    }
};

// TODO: This is temporary mock for get Dimension Details this will be replace with code below:

//
// export const fetchBillReceivers = (
//     token: string,
//     companyId: number,
//     environment: CurrentEnvironment,
// ): Promise<ApiResponse<IBillReceiversResponse>> => {
//     return get(`/companies/${companyId}/accounting/billReceivers`, {
//         token,
//         environment,
//     })
// }

export const fetchBillReceivers = async (
    token: string,
    companyId: number,
    environment: CurrentEnvironment
): Promise<ApiResponse<IBillReceiversResponse>> => {
    const response = await fetch(
        `${MOCK_API_URL}/companies/${companyId}/accounting/billReceivers`,
        {
            method: 'GET',
            headers: getHeadersFromOptions({ token, environment }),
        }
    );

    const text = await response.text();

    try {
        const data = JSON.parse(text);

        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: 'GET',
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: []
        } as ISuccessResponse<IBillReceiversResponse>;
    } catch {
        throw Error('Impossible to parse data')
    }
};

// TODO: This is temporary mock for get Meeting Service Config will be replace with code below:

// export const getMeetingServiceConfig = (
//     token: string,
//     userId: number,
//     userCanteenId: number,
//     environment: CurrentEnvironment,
//     locale: string,
// ): Promise<ApiResponse<IMeetingServiceConfigResponse>> => {
//     return get(`/users/${userId}/merchants/${userCanteenId}/meetingService/config`, {
//         token,
//         environment,
//         locale
//     })
// }

export const getMeetingServiceConfig = async (
    token: string,
    userId: number,
    userCanteenId: number,
    environment: CurrentEnvironment,
    locale: string,
): Promise<ApiResponse<IMeetingServiceConfigResponse>> => {
    const response = await fetch(
        `${MOCK_API_URL}/users/${userId}/merchants/${userCanteenId}/meetingService/config`,
        {
            method: 'GET',
            headers: getHeadersFromOptions({ token, environment, locale }),
        }
    );

    const text = await response.text();

    try {
        const data = JSON.parse(text);

        return {
            type: ApiResponseTypes.SUCCESS,
            data,
            method: 'GET',
            url: response.url,
            requestHeaders: [],
            responseCode: response.status,
            statusText: response.statusText,
            responseHeaders: []
        } as ISuccessResponse<any>;
    } catch {
        throw Error('Impossible to parse data')
    }
};
